import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import GroupAPI from '../../../src/api/scheduleAssignment/api-group-schedule-assignment';

export const fetchGroups = createAsyncThunk('group/fetch', async (_, thunkAPI) => {
  try {
    const res = await GroupAPI.getAll();
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const addGroup = createAsyncThunk('group/add', async (payload, thunkAPI) => {
  try {
    const res = await GroupAPI.add(payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateGroup = createAsyncThunk('group/update', async (payload, thunkAPI) => {
  try {
    const res = await GroupAPI.update(payload.id, payload);
    return res.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteGroup = createAsyncThunk('group/delete', async (ids, thunkAPI) => {
  try {
    await GroupAPI.delete(ids);
    return ids;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const groupSlice = createSlice({
  name: 'group',
  initialState: { list: [], loading: false, error: '' },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroups.pending, (s) => { s.loading = true; s.error = ''; })
      .addCase(fetchGroups.fulfilled, (s, a) => { s.loading = false; s.list = [...a.payload]; })
      .addCase(fetchGroups.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(addGroup.fulfilled, (s, a) => { s.list.unshift(a.payload); })
      .addCase(updateGroup.fulfilled, (s, a) => {
        const idx = s.list.findIndex((g) => g.id === a.payload.id);
        if (idx !== -1) s.list[idx] = a.payload;
      })
      .addCase(deleteGroup.fulfilled, (s, a) => {
        const ids = Array.isArray(a.payload) ? a.payload : [a.payload];
        s.list = s.list.filter((g) => !ids.includes(g.id));
      });
  },
});

export default groupSlice.reducer;
